import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Chip } from '@mui/material'
import { colors } from '@global/constants'

interface Props {
  fontcolor: string
  backgroundcolor: string
}

export const StyledChip = styled(Chip)<Props>`
  color: ${props => props.fontcolor};
  background-color: ${props => props.backgroundcolor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
`

export const progress = css`
  margin-left: 7px;
  color: ${colors.white};
`
